module.exports = __webpack_public_path__ + "img/dentalfit_15_a.8f0522cc.jpg";